import { render, staticRenderFns } from "./ChangeTripBoat.vue?vue&type=template&id=83ad026c&scoped=true&"
import script from "./ChangeTripBoat.vue?vue&type=script&lang=js&"
export * from "./ChangeTripBoat.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTripBoat.vue?vue&type=style&index=0&id=83ad026c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ad026c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAlert,VBtn,VCard,VDialog,VIcon,VSelect})
